/* HARMONY — Tabela de medidas (modal único, compartilhado pela loja inteira)
   Portado do protótipo (harmony-prototype.html, "SIZE GUIDE MODAL" e
   "TABELA DE MEDIDAS: destaque da linha recomendada"). Abre a partir de
   qualquer botão ".size-guide-btn" na página (produto, card de coleção,
   etc.) via delegação de evento — não precisa reconectar listener por
   página, já que o modal é renderizado uma vez em layout/theme.liquid. */
(function () {
  function init() {
    var modal = document.getElementById('size-modal');
    if (!modal || modal._hmyInit) return;
    modal._hmyInit = true;

    var closeBtn = modal.querySelector('.modal-close');

    function open() {
      modal.classList.add('open');
      highlight();
    }
    function close() {
      modal.classList.remove('open');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.size-guide-btn')) open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });

    // Destaca a linha do tamanho recomendado quando o visitante já salvou
    // altura/peso no módulo "Ver o caimento" (ainda não migrado — até lá,
    // window.HARMONY_FIT não existe e isto não faz nada).
    function highlight() {
      var table = document.getElementById('sc-table');
      if (!table) return;
      var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));
      rows.forEach(function (r) {
        r.classList.remove('hi');
      });
      if (!window.HARMONY_FIT) return;
      var mine = window.HARMONY_FIT.savedMeasures && window.HARMONY_FIT.savedMeasures();
      if (!mine) return;
      var rec = window.HARMONY_FIT.recommend && window.HARMONY_FIT.recommend(mine.height, mine.weight);
      if (!rec) return;
      rows.forEach(function (r) {
        if (r.getAttribute('data-size') === rec) r.classList.add('hi');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
